import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage3Avaleht from "./pages/Webpage3Avaleht";
import Webpage16Isikuandmete_t____tlemine_kandideerimisel from "./pages/Webpage16Isikuandmete_t____tlemine_kandideerimisel";
import Webpage17T____tamine_IT_Projektis from "./pages/Webpage17T____tamine_IT_Projektis";
import Webpage18Full_stack_arendaja_t____kuulutus___IT_Projekt from "./pages/Webpage18Full_stack_arendaja_t____kuulutus___IT_Projekt";
import Webpage19Backend_arendaja_t____kuulutus___IT_Projekt from "./pages/Webpage19Backend_arendaja_t____kuulutus___IT_Projekt";
import Webpage21Home from "./pages/Webpage21Home";
import Webpage22Teenused from "./pages/Webpage22Teenused";

var baseURL = 'https://web.kassahaldus.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI2IiwianRpIjoiMTkzYjYzNGI0NmFlN2Q1ODY5ZjY0ZDViMzgwMzBiNmNkZjYzNTQ3YjA1ZDY0YjFjMGVlNjY2MTc3MmVlZTM1YjE3M2MyNjcyOWMyZTk5NGEiLCJpYXQiOjE3ODQ0NjQ1NDAuNTAxODY0LCJuYmYiOjE3ODQ0NjQ1NDAuNTAxODY4LCJleHAiOjE3ODQ1NTA5NDAuNDk3NDgyLCJzdWIiOiI4Iiwic2NvcGVzIjpbXX0.MDx1ZsMAHLGbKXdStUntlzCEjOzxpHoYIh4Iq0M67Vz1DxCJIvdn7X-Py530HQ4lXqs8X-t9Z48qXfk94CPkjbOAX8cyEjbp6qE2VmvGeBvu61lgjh52iPu2rSvjadaa_tmRWuVHF1Ssqc0o_jgV-Z0IPn4YmG1vMv42Z2FVnMcxat7vNqvFhgDjyuJAbVdHnUeWVtXYcnU2ThhmDlR1JgyiH92O0d8nPQhxHMtfforg7KPa_Fvr6x-Qz99yxjf28qZgQzZM5BPCe-T4tdfYbUrhBVoJoqpo8BiJwCYyzl8l6DTEeFXCRTL0uP_cIxtTBAdztFqsbws008XDmqlejIsUPMTzZVrp8tpP1l-5G40pVcmq4lJp412rrbT0LTWIXM-mzvzx2_jOifrcRwy5DVfh-ZpY5MJTsI0p_D_qy4WkSDa_XeGBApy-SI3BQd4uE8SB-dmtJBXPytpQNPwby8MUF1j09HfPg8ZCNubbp0if3ITYGnI9KirhkTxWVG6khPCfTgU9cphDVSqHeNFp-s3XsQ-SAjHanTm7RTdbYdPQZSKj-a0_nUHjUrnhCJrPG90Yq0jGQ1Ow0kpHdtKDLE01qS3wxEkW_n8uyVH3ws2D0r2HoTEZYB4omO9VSo5Hx-C-nMo-2YjnrHttw9hCC_FuD2OsgQ0noHL7QlS7oMg',
    'Access-api-key': "eyJpdiI6IlppWnJBdEdmMG1EeUNPSi9iL2tleXc9PSIsInZhbHVlIjoiRDJPemMrREVDVFhGeW0rQXpEUnMrZz09IiwibWFjIjoiN2JjOTU5NGI5ODA0YzVlYWEyODU5YmQ3YWNlMWI0YTAzYjZiYjQ1MmQxYWUyZDljNmQ0NWY4ZTY3NTgwZTBhMSIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6IlptYlo0Mm0ydW5pQmVUVW9CdmxSZXc9PSIsInZhbHVlIjoiRFhnYXpwTitraGhOMnR6S3BCVkVjZz09IiwibWFjIjoiZGFhN2MxMjMwZWIxYzEwMjJlNTliNWU4NmMzZTZkNjc0MjlhMjgxMDE1MDYxZjRiODA2NDc5MWIzN2ZhZWM1NiIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: "GTM-MXH2B4"
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                            <Route path="/et/" element={<Webpage3Avaleht />} exact />;
                                                                    <Route path="/et/isikuandmed" element={<Webpage16Isikuandmete_t____tlemine_kandideerimisel />} exact />;
                                                                    <Route path="/et/tootamine-it-projektis" element={<Webpage17T____tamine_IT_Projektis />} exact />;
                                                                    <Route path="/et/full-stack" element={<Webpage18Full_stack_arendaja_t____kuulutus___IT_Projekt />} exact />;
                                                                    <Route path="/et/backend" element={<Webpage19Backend_arendaja_t____kuulutus___IT_Projekt />} exact />;
                                                                    <Route path="/en/" element={<Webpage21Home />} exact />;
                                                                    <Route path="/et/teenused" element={<Webpage22Teenused />} exact />;
                                                                
                                            <Route path="itprojekt.ee/et/isikuandmed" element={<Redirect to="itprojekt.ee/et/tootamine-it-projektis/isikuandmed" />} exact />;
                                                                <Route path="*" element={<Webpage3Avaleht />} exact />;
                                        </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}